module.exports = __webpack_public_path__ + "static/media/goal01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/goals/goal01.svg
// module id = 61
// module chunks = 0